import { makeStyles } from 'tss-react/mui';

import { MOBILE_BREAK_POINT } from 'app/constants';

export default makeStyles({ name: 'Pricing' })((theme) => ({
    title: {
        marginTop: 40,
        marginBottom: 24
    },
    period: {
        margin: '0 auto'
    },
    plans: {
        marginTop: 80,
        marginBottom: 160,
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            marginTop: 40,
            marginBottom: 96
        }
    },
    customers: {
        marginTop: 160,
        marginBottom: 160,
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            marginTop: 96,
            marginBottom: 96
        }
    },
    estimation: {
        marginTop: 160,
        marginBottom: 160,
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            marginTop: 96,
            marginBottom: 96
        }
    },
    questions: {
        marginTop: 160,
        marginBottom: 160,
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            marginTop: 96,
            marginBottom: 96
        }
    }
}));
